var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"text-primary cursor-pointer font-weight-600 margin-a-0",on:{"click":_setup.openTripModificationStartDialog}},[_vm._v(" Edit Trip ")])
}
var staticRenderFns = []

export { render, staticRenderFns }